<template>
  <div class="passwordUpdate">
    <label>旧密码：</label><input type="text" class="input_border" v-model="oldPassword" placeholder="请输入旧密码"><br>
    <label>新密码：</label><input type="text" class="input_border" v-model="newPassword" placeholder="请输入新密码">
    <span>密码由6-16位半角字符（字母、数字、符号）组成，区分大小写</span><br>
    <label>确认密码：</label><input type="text" class="input_border" v-model="confirmPassword" placeholder="确认密码"><br>

    <div class="sbt_box">
      <button :class='["add_btn","add","icon_btn","clearborder"]' @click="updatePassword()">保存</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "passwordUpdate",
  data() {
    return {
      oldPassword:"",
      newPassword:"",
      confirmPassword:"",
    };
  },
  methods: {
    updatePassword: function () {
      if(this.newPassword != this.confirmPassword){
        alert("两次密码不一致");
        return;
      }
      fetch("/api/v1/user/password/update", {
        method: 'post',
        body: JSON.stringify({
          user_id: "35fa2070-ed7e-4369-9434-1a8ceaedfb02",
          old_password: this.oldPassword,
          new_password: this.newPassword,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            alert(data.msg);
          } else{
            alert(data.msg);
          }
      }).catch((error) => {
          console.log(error);
      });
    },
  },
  mounted() {

  },
  created() {},
  destroyed: function() {}
};
</script>

<style scoped>
.passwordUpdate {
  width: 98%;
  height: 98%;
  box-sizing: border-box;
  background: #0b2f54;
  border-radius: 10px;
  margin-left: 1%;
  margin-top:1%;
}
.passwordUpdate{
  padding-top:100px;
}
.passwordUpdate label{
  width:200px;
  color: #ffffff;
  text-align: right;
  margin: 0 10px 0 13%;
}
.passwordUpdate span{
  color: #679ed6;
  font-size: 14px;
}
.input_border{
  border-radius: 4px;
  border:1px solid #556e88 !important;
  background:none;
  padding-left: 10px;
  height: 32px;
  margin: 10px 0 10px 0;
  width: 40%;
  color:#ffffff;
}

.add_btn {
  width: 110px;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
  float: right;
  margin-right: 20px;
}
.clearborder {
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Setting/password_update.vue